import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';  // Tailwind imports
import { pdfjs } from 'react-pdf';

// Configure PDF.js worker once, globally — avoids race conditions when
// multiple PDF viewer components mount simultaneously.
pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.min.mjs`;

// Suppress benign PDF.js AbortErrors that bubble up when a Document component
// unmounts while range-requests are still in flight. These are harmless cleanup
// cancellations but CRA's error overlay treats them as uncaught errors.
window.addEventListener('unhandledrejection', (event) => {
  if (
    event.reason instanceof Error &&
    event.reason.name === 'AbortError' &&
    event.reason.message &&
    event.reason.message.includes('signal is aborted')
  ) {
    event.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
